<template>
  <div>
    <modal-crear-editar :configuracion="configuracion_modal" @realizado="restablecer_inputs"></modal-crear-editar>
    <tablita :cols="columnas" @cargar="cargar($event)" @cargar_url="cargar_url($event)" @nuevo="crear"
      @editar="editar($event)" :configuracion="configuracion_tabla" @refresh="refrescar($event)"></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "id",
        label: "ID",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "id",
      },
      //{key:'nombre',label:'Nombre',busqueda:'',tipo:'string',searchable:true,path:'nombre'},
      {
        key: "nombre",
        label: "Nombre",
        busqueda: "",
        tipo: "string_badge",
        searchable: true,
        path: "nombre",
        color_badge: "color_badge",
        path_badge: "texto_badge",
        mostrar_badge: "mostrar_badge",
      },
      {
        key: "codigo_siep",
        label: "Codigo SIEP",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "codigo_siep",
      },
      {
        key: "tipo_dependencias_id",
        label: "Tipo Sucursal",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "tipo_dependencia.nombre",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "empresas_id",
        label: "Empresa",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/empresas",
        parametro: "nombre",
        searchable: true,
        path: "empresa.nombre",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "dependencias_id",
        label: "Sucursal Padre",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/dependencias",
        parametro: "nombre",
        searchable: true,
        path: "sucursal_padre.id_nombre",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "id_nombre",
      },
      {
        key: "tiene_html_km",
        label: "Km",
        busqueda: "",
        tipo: "html",
        searchable: true,
        path: "tiene_km_html",
      },

      //{key:'ciudades_id',label:'Comuna',busqueda:'',tipo:'select-loadable',ruta:'/comunas',parametro:'nombre',searchable:true,path:'comuna.nombre',opciones:[],valor_opcion:'id',label_opcion:'nombre'},
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "texto",
        key: "nombre",
        valor: "",
        label: "Nombre (*)",
        disabled: true,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "codigo_siep",
        valor: "",
        label: "Codigo SIEP",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "nombre_certificado_disposicion",
        valor: "",
        label: "Nombre Certificado Disposición",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "select",
        key: "tipo_dependencias_id",
        valor: "",
        label: "Tipo Sucursal (*)",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "select-loadable",
        key: "empresas_id",
        valor: "",
        label: "Empresa",
        busqueda: "",
        ruta: "/empresas",
        parametro: "nombre",
        disabled: false,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },

      {
        cols: 4,
        tipo: "select-loadable",
        key: "dependencias_id",
        valor: "",
        label: "Sucursal Padre",
        busqueda: "",
        ruta: "/dependencias",
        parametro: "nombre",
        disabled: false,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "id_nombre",
      },
      {
        cols: 4,
        tipo: "select",
        key: "ciudades_id",
        valor: "",
        label: "Comuna",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "telefono",
        valor: "",
        label: "Telefono",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "email",
        valor: "",
        label: "Email",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "numero",
        key: "km",
        valor: "",
        label: "Kilometros (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "numero",
        key: "codigo_sucursal",
        valor: "",
        label: "Codigo Sucursal",
        disabled: true,
      },
      {
        cols: 4,
        tipo: "select",
        key: "region",
        valor: "",
        label: "Región",
        opciones: [{ id: 1, nombre: "I Región de Tarapacá" },
        { id: 2, nombre: "II Región de Antofagasta" },
        { id: 3, nombre: "III Región de Atacama" },
        { id: 4, nombre: "IV Región de Coquimbo" },
        { id: 5, nombre: "V Región de Valparaíso" },
        { id: 6, nombre: "VI Región del Libertador General Bernardo O'Higgins" },
        { id: 7, nombre: "VII Región del Maule" },
        { id: 8, nombre: "VIII Región del Biobío" },
        { id: 9, nombre: "IX Región de La Araucanía" },
        { id: 10, nombre: "X Región de Los Lagos" },
        { id: 11, nombre: "XI Región de Aysén del General Carlos Ibáñez del Campo" },
        { id: 12, nombre: "XII Región de Magallanes y de la Antártica Chilena" },
        { id: 13, nombre: "Región Metropolitana de Santiago (RM)" },
        { id: 14, nombre: "XIV Región de Los Ríos" },
        { id: 15, nombre: "XV Región de Arica y Parinacota" },
        { id: 16, nombre: "XVI Región de Ñuble" }],
        valor_opcion: "id",
        label_opcion: "nombre",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Sucursal",
      ancho: "xl",
      ruta: "/dependencias",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Sucursales",
      titulo_boton: "Crear Sucursal",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.$emit("spinner", true);
    this.cargar_tipo_dependencias();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_tipo_dependencias() {
      await this.axios
        .get(
          `${this.api}/tipo_dependencias?limit=99999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.$set(this.columnas[3], "opciones", res.data.data.data);
          this.$set(this.inputs[3], "opciones", res.data.data.data);
          //console.log('opciones',res.data.data.data);
          //this.inputs[1].opciones = res.data.data.data;
          //this.cargar('');
          //this.cargar_empresas();
        })
        .catch((e) => {
          //alert(e);
        });
      this.cargar_empresas();
    },
    async cargar_empresas() {
      await this.axios
        .get(
          `${this.api}/empresas?tipo_empresa_ids=4&limit=99999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.$set(this.columnas[4], "opciones", res.data.data.data);
          this.$set(this.inputs[4], "opciones", res.data.data.data);
          //this.cargar_comunas();
          //this.cargar("");
        })
        .catch((e) => {
          //alert(e);
        });
      this.cargar_comunas()
    },
    async cargar_comunas() {
      await this.axios
        .get(`${this.api}/comunas?limit=99999999`, this.cabeceras_json)
        .then((res) => {
          this.$set(this.columnas[6], "opciones", res.data.data.data);
          this.$set(this.inputs[6], "opciones", res.data.data.data);
          //console.log('opciones',res.data.data.data);
          //this.inputs[1].opciones = res.data.data.data;
          //this.cargar("");
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("cargar");
    },
    async cargar($event) {
      this.$emit("spinner", true);
      this.pagina_actual = `${this.api}/dependencias${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/dependencias${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.inputs[0].disabled = false;
      this.inputs[4].disabled = false;
      this.inputs[10].disabled = false;

      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/dependencias`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.inputs[0].disabled = true;
      this.inputs[4].disabled = true;
      this.inputs[10].disabled = true;

      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/dependencias/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },

    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>